module.exports = __webpack_public_path__ + "img/FAQ-3.54e86626.gif";